import { combineReducers } from "redux";
import Users from "./Users";
import Events from "./Events";

const Reducers = combineReducers({
  Users,
  Events,
});

export default Reducers;
